import { Navbar } from "@/components/marketing/Navbar";
import { Footer } from "@/components/marketing/Footer";

export const AuthCard = ({ children, testid = "auth-card" }) => (
  <div className="flex min-h-screen flex-col bg-oath-bg">
    <Navbar />
    <main className="mx-auto flex w-full max-w-md flex-1 flex-col px-5 pb-24 pt-36">
      <div className="animate-fade-up rounded-3xl border border-gray-200 bg-white p-7 shadow-sm sm:p-8" data-testid={testid}>
        {children}
      </div>
    </main>
    <Footer />
  </div>
);

export default AuthCard;
